import api from './api';
import type { Compound, Offering, CreateOfferingData, UpdateOfferingData } from '../types';

export const offeringService = {
  /**
   * Get all available compounds with their dosage varieties
   */
  async getCompounds(): Promise<Compound[]> {
    const response = await api.get<Compound[]>('/company/compounds');
    return response.data;
  },

  /**
   * Get all offerings for the company
   */
  async getOfferings(): Promise<Offering[]> {
    const response = await api.get<Offering[]>('/company/offerings');
    return response.data;
  },

  /**
   * Create a new offering
   */
  async createOffering(data: CreateOfferingData): Promise<Offering> {
    const response = await api.post<Offering>('/company/offerings', data);
    return response.data;
  },

  /**
   * Update an existing offering
   */
  async updateOffering(id: string, data: UpdateOfferingData): Promise<Offering> {
    const response = await api.patch<Offering>(`/company/offerings/${id}`, data);
    return response.data;
  },

  /**
   * Delete an offering
   */
  async deleteOffering(id: string): Promise<void> {
    await api.delete(`/company/offerings/${id}`);
  },

  /**
   * Toggle offering active status
   */
  async toggleActive(id: string, isActive: boolean): Promise<Offering> {
    const response = await api.patch<Offering>(`/company/offerings/${id}`, { isActive });
    return response.data;
  },
};
